<div class="status-chip-wrapper">
  <div
    *ngIf="type$ | async as type"
    class="status-chip-container"
    [class.hidden]="!type"
  >
    <div
      class="status-chip"
      matTooltipPosition="above"
      matTooltipClass="custom-tooltip"
      (mouseenter)="showTooltip = true"
      (mouseleave)="showTooltip = false"
    >
      <div class="chip-icon-section">
        <mat-icon
          [ngClass]="type === 'existing' ? 'chip-green' : 'chip-yellow'"
          class="material-symbols-outlined icon-display"
        >
          {{ type === "existing" ? "cell_merge" : "open_with" }}
        </mat-icon>
      </div>

      <div class="chip-text-section">
        <span>{{
          type === "existing" ? "Verdichtung aktiv" : "Erweiterung aktiv"
        }}</span>
      </div>
    </div>

    <div
      *ngIf="showTooltip"
      [innerHTML]="type === 'existing' ? tooltipExisting : tooltipExtension"
      class="custom-tooltip"
    ></div>
  </div>
</div>
